// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2NNgL","footerUL":"Footer_footerUL__3_EnK"};